import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import admin from './admin'
import cart from './cart'
import order from './order'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    admin,
    cart,
    order,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
})
